(function($){

    // Inject BS4 modal template if block gallery exists & any of the images are linked to source

    // Create template for future usage & not clog template so in future this can be retrofitted somewhere
    const modalTemplate = `<div class="modal fade" id="modal__image" tabindex="-1" role="dialog" aria-labelledby="modal__image"aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <!-- <span aria-hidden="true">&times;</span> -->
              </button>
              </div>
              <div class="modal-body"></div>
            </div>
          </div>
        </div>`;

    let $_gallery = $('.wp-block-gallery');

    if ( $_gallery.length ) {

        $_gallery.each(function(e){

            // Check within the gallery, if an anchor is set
            if ( !$(this).find('figure a').length ) {
                return;
            }

            // Just check if the modal isn't already injected to prevent double ups
            if( !$('#modal__image').length ) {

                $('body').append(modalTemplate);

            }

            // Now lets assign some data attributes for the links to trigger the modal

            $('a', this).each(function(e){

                let imgUrl = $(this).attr('href'),
                    alt    = $(this).attr('alt');

                $(this).attr({
                    'data-image'   : imgUrl,
                    'data-alt'     : alt,
                    'data-toggle'  : 'modal',
                    'data-target'  : '#modal__image'
                });

                // prevent default click
                $(this).on('click', function(e){
                    e.preventDefault();
                });

            });

        }).promise().done(function(){

            // Now we assign the modal so it correctly injects the image inside
            $('#modal__image').on('show.bs.modal', function(e){
                let triggerElem = $(e.relatedTarget),
                    imgUrl      = triggerElem.attr('data-image'),
                    alt         = triggerElem.attr('data-alt'),
                    $_modal     = $(this);

                $_modal.find('.modal-body').html('<img src="'+ imgUrl +'" alt="'+ alt +'">');

            });

            $('#modal__image').on('hidden.bs.modal', function(e){

                let $_modal = $(this);

                $_modal.find('.modal-body').html('');

            });

        });

    }


})(jQuery);